var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-border md:w-full md:max-h-full-fixed md:p-4 xl:p-8 md:h-screen md:flex md:flex-row-reverse"},[_c('aside',{},[_c('o-sidebar')],1),_c('minimal-layout',{attrs:{"has-sidebar":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }